export enum AlloyOutcome {
  Success = "success",
  Approved = "Approved",
  Denied = "Denied",
  ManualReview = "Manual Review",
  DocumentResubmit = "Document Resubmit",
  PreviouslyApproved = "Previously Approved"
}
